// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#000","primaryFont":"Nunito","progressBarBg":"#b9b9b9","button":"Button_button__2Lf63","invertedButton":"Button_invertedButton__2eb88"};